<template>
  <div>
    <!-- 面包屑导航 -->
<!--    <el-breadcrumb separator-class="el-icon-arrow-right">-->
<!--      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>-->
<!--      <el-breadcrumb-item>车辆管理列表</el-breadcrumb-item>-->
<!--    </el-breadcrumb>-->
    <!-- 卡片 -->
    <el-card class="box-card">
      <!-- 搜索  新增-->
           <el-form
            :inline="true"
            :model="searchForm"
            :rules="searchRules"
            ref="searchForRef"
            autocomplete="on"
            size="mini">
            <el-form-item label="关键字">
              <el-input v-model="searchForm.keywords" placeholder="请输入车牌号/所有人" clearable type="text"></el-input>
            </el-form-item>
             <el-form-item label="车主">
               <el-input v-model="searchForm.username" placeholder="请输入车主" clearable type="text"></el-input>
             </el-form-item>
             <el-form-item label="车架号">
               <el-input v-model="searchForm.vin" placeholder="请输入车架号" clearable type="text"></el-input>
             </el-form-item>
             <el-form-item label="车辆状态">
               <el-select  v-model="searchForm.is_del" placeholder="请选择状态类型">
                 <el-option label="正常" :value="2"></el-option>
                 <el-option label="过户" :value="3"></el-option>
                 <el-option label="报废" :value="4"></el-option>
               </el-select>
             </el-form-item>
             <el-form-item>
               <el-button  type="success" @click="searchSubmit()">搜索</el-button>
               <!-- <el-button @click="searchRest()">重置</el-button> -->
             </el-form-item>
             <el-form-item>
               <el-button size="mini" type="primary" @click="addData">新增车辆</el-button>
             </el-form-item>
          </el-form>


      <!-- 表格 -->
      <el-table
        ref="multipleTable"
        :data="tableLoadData"
        stripe
        border
        size="mini"
        height="450"
        :header-cell-style="{background:'#e5e5e5',color:'#333333'}">
        <el-table-column
                label="车牌号"
                prop="plate_number"
                min-width="5%"
                :show-overflow-tooltip='true'
        >
        </el-table-column>
        <el-table-column
          label="所有人"
          min-width="5%"
          prop="allPerson"
          :show-overflow-tooltip='true'
        >
        </el-table-column>
        <!--
        <el-table-column
            label="车主"
            width="80px"
            prop="username"
            :show-overflow-tooltip='true'
        >
        </el-table-column>-->
        <el-table-column
          label="车架号"
          min-width="5%"
          prop="vin"
          :show-overflow-tooltip='true'
        >
        </el-table-column>
          <el-table-column
                  label="品牌型号"
                  min-width="5%"
                  prop="model"
                  :show-overflow-tooltip='true'
          >
          </el-table-column>
          <el-table-column
                  label="发动机号码"
                  min-width="5%"
                  prop="engine_number"
                  :show-overflow-tooltip='true'
          >
          </el-table-column>
          <el-table-column
                  label="类型"
                  min-width="4%"
                  prop="vehicle_type"
                  :show-overflow-tooltip='true'
          >
          </el-table-column>
          <el-table-column
                  label="整备质量"
                  min-width="4%"
                  prop="curb_weight"
                  :show-overflow-tooltip='true'
          >
          </el-table-column>
          <el-table-column
                  label="使用性质"
                  min-width="5%"
                  prop="use_character"
                  :show-overflow-tooltip='true'
          >
          </el-table-column>
        <el-table-column
          label="注册日期"
          min-width="5%"
          prop="register_date"
          :show-overflow-tooltip='true'
        >
        </el-table-column>
        <el-table-column
          label="核定载人数"
          min-width="5%"
          prop="seating_capacity"
          :show-overflow-tooltip='true'
        >
        </el-table-column>
        <el-table-column
          label="总质量"
          min-width="5%"
          prop="total_mass"
          :show-overflow-tooltip='true'
        >
        </el-table-column>

        <el-table-column
          label="外廓尺寸"
          min-width="5%"
          prop="out_to_out"
          :show-overflow-tooltip='true'
        >
        </el-table-column>
        <el-table-column
          label="准牵引总质量"
          min-width="6%"
          prop="traction_mass"
          :show-overflow-tooltip='true'
        >
        </el-table-column>

        <el-table-column
          label="联系电话"
          min-width="5%"
          prop="mobile"
          :show-overflow-tooltip='true'
        >
        </el-table-column>

        <el-table-column
                label="创建人"
                min-width="5%"
                prop="operator_name"
                :show-overflow-tooltip='true'
        >
        </el-table-column>
        <el-table-column
                label="创建日期"
                min-width="5%"
                :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
           {{ scope.row.add_time | dateFormat }}
          </template>
        </el-table-column>

        <el-table-column
          label="操作"
          min-width="20%"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <el-button type="warning" size="mini" icon="el-icon-edit" @click="handelEdit(scope.row)"></el-button>
            <el-button type="danger" size="mini" icon="el-icon-delete" @click="handelDel(scope.row)"></el-button>

            <el-button v-if="scope.row.is_del ==3" type="info" size="mini" @click="transferList(scope.row.id,3)">车辆已过户</el-button>
            <el-button v-if="scope.row.is_del ==4" type="info" size="mini" @click="transferList(scope.row.id,4)">车辆已报废</el-button>
            <el-button v-if="scope.row.is_del ==2" type="success" size="mini"  @click="handDispose(scope.row)">过户/报废</el-button>
            <el-button type="primary" size="mini" plain @click="handelDialog(scope.row)">查看图片</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="block" style="margin-top:10px">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 100]"
          :page-size="limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
      <!--<pagination :total.sync="total" :pageNum.sync="pageNum" :limit.sync="limit"></pagination> todo-->
    </el-card>
    <!-- 新增编辑弹框 -->
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="996px" style="overflow: auto;height: auto">
      <el-form :model="form" size="mini" :rules="rules" ref="form" label-width="110px">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="公司名称" prop="name" >
              <el-input v-model="form.name" autocomplete="off" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="法人" prop="corporation">
              <el-input v-model="form.corporation" autocomplete="off" readonly></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="类型">
              <el-input v-model="form.type" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="社会信用代码" prop="credit_code">
              <el-input v-model="form.credit_code" autocomplete="off" readonly></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="成立日期" prop="">
              <el-input v-model="form.incorporation_date" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="注册资本" prop="">
              <el-input v-model="form.registered_capital" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="证件编号" prop="">
              <el-input v-model="form.certificate_no" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="组成形式" prop="">
              <el-input v-model="form.composition" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="税号" prop="">
              <el-input v-model="form.taxes_no" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="核准日期" prop="">
              <el-input v-model="form.issue_date" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="地址" prop="">
              <el-input v-model="form.address" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号" prop="">
              <el-input v-model="form.mobile" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="开户行" prop="">
              <el-input v-model="form.bank" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="有效期" prop="">
              <el-input v-model="form.lifespan" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="银行开户人" prop="">
              <el-input v-model="form.bank_account" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-tooltip :content="form.business_scope" placement="bottom" effect="dark">
              <el-form-item label="经营范围" >
                <el-input v-model="form.business_scope" type="textarea" autocomplete="off"></el-input>
              </el-form-item>
            </el-tooltip>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="reset_dialogForm('form')">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="车辆信息图片" :visible.sync="uploadDialog" class="custom-dialog" width="996px" style="overflow: auto;height: auto">

      <template>
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <el-tab-pane label="主车信息" name="first">
            <el-row :gutter="24">
              <el-col :span="4">
                行驶证图片 ：
              </el-col>
                <el-col :span="8">
              <span v-if="uploadImg.file_url">
                  <el-image @click="bigImg(`${uploadImg.file_url}`)"
                            style="width: 100px; height: 100px;"
                            :src="`${uploadImg.file_url}`"
                            :preview-src-list="[srcList]"
                            :z-index="99999"
                  ></el-image>
                </span>

              <span v-else>暂无</span>
              </el-col>
              <el-col :span="4">
                车主身份证图片 :
              </el-col>
              <el-col :span="8">
              <span v-if="uploadImg.cardImageUrl">
                  <el-image @click="bigImg(`${uploadImg.cardImageUrl}`)"
                            style="width: 100px; height: 100px;"
                            :src="`${uploadImg.cardImageUrl}`"
                            :preview-src-list="[srcList]"
                            :z-index="99999"
                  ></el-image>
                </span>

              <span v-else>暂无</span>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="主车大本信息" name="second">
            <el-row :gutter="24">
              <el-col :span="12" v-if="main_big_book" v-for="(value,key) in main_big_book" :key="key">
                <span>
                  <strong>主车大本照片 第{{key+1}}页</strong>
                  <el-image @click="bigImg(`${value.image_url}`)"
                            style="width: 100px; height: 100px;"
                            :src="`${value.image_url}`"
                            :preview-src-list="[srcList]"
                            :z-index="99999"
                  ></el-image>
                </span>

              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="挂车大本信息" name="three">
            <el-row :gutter="24">
              <el-col :span="12" v-if="hang_big_book" v-for="(value,key) in hang_big_book" :key="key">
                <span>
                  <strong>挂车大本照片 第{{key+1}}页</strong>
                  <el-image @click="bigImg(`${value.image_url}`)"
                            style="width: 100px; height: 100px;"
                            :src="`${value.image_url}`"
                            :preview-src-list="[srcList]"
                            :z-index="99999"
                  ></el-image>
                </span>

              </el-col>

            </el-row>
          </el-tab-pane>
          <el-tab-pane label="营运证信息" name="four">
            <el-row :gutter="24">
              <el-col :span="12" v-if="trading_card" v-for="(value,key) in trading_card" :key="key">
                <span>
                  <strong>营运证信息照片 第{{key+1}}页</strong>
                  <el-image @click="bigImg(`${value.image_url}`)"
                            style="width: 100px; height: 100px;"
                            :src="`${value.image_url}`"
                            :preview-src-list="[srcList]"
                            :z-index="99999"
                  ></el-image>
                </span>

              </el-col>

            </el-row>

          </el-tab-pane>
          <el-tab-pane label="驾驶员三证" name="five">
            <div v-for="(value,key) in driver_info" :key="key">
            <el-row :gutter="24" style="border-bottom: 1px #8c939d dashed ;padding-bottom: 10px; margin-bottom: 10px;">
              <el-col :span="2">
                第{{key+1}}位
              </el-col>
              <el-col :span="2">
                身份证
              </el-col>
              <el-col :span="5">
                <el-image v-if="value.card_img" @click="bigImg(`${value.card_img}`)"
                          style="width: 100px; height: 100px;"
                          :src="`${value.card_img}`"
                          :preview-src-list="[srcList]"
                          :z-index="99999"
                ></el-image>
              </el-col>
              <el-col :span="2">
               上岗证
              </el-col>
              <el-col :span="5">
                <el-image v-if="value.work_img" @click="bigImg(`${value.work_img}`)"
                          style="width: 100px; height: 100px;"
                          :src="`${value.work_img}`"
                          :preview-src-list="[srcList]"
                          :z-index="99999"
                ></el-image>
              </el-col>
              <el-col :span="2">
                驾驶证
              </el-col>
              <el-col :span="5">
                <el-image v-if="value.driver_img" @click="bigImg(`${value.driver_img}`)"
                          style="width: 100px; height: 100px;"
                          :src="`${value.driver_img}`"
                          :preview-src-list="[srcList]"
                          :z-index="99999"
                ></el-image>
              </el-col>

            </el-row>
            </div>
          </el-tab-pane>
          <el-tab-pane label="附件信息" name="six">
            <el-row :gutter="24">
              <el-col :span="12" v-if="attachment" v-for="(value,key) in attachment" :key="key">
                <span>
                  <strong>附件信息 第{{key+1}}页</strong>
                  <el-image @click="bigImg(`${value.image_url}`)"
                            style="width: 100px; height: 100px;"
                            :src="`${value.image_url}`"
                            :preview-src-list="[srcList]"
                            :z-index="99999"
                  ></el-image>
                </span>

              </el-col>

            </el-row>

          </el-tab-pane>
        </el-tabs>

      </template>


    </el-dialog>

    <el-dialog title="修改车辆过户/报废" :visible.sync="carDisposeDialog" class="custom-dialog" width="596px" style="overflow: auto;height: auto">
      <el-form label-width="110px">
            <el-form-item label="选择" size="small">
              <el-select  v-model="disposeType" placeholder="请选择上传类型">
                <el-option label="过户" :value="1"></el-option>
                <el-option label="报废" :value="2"></el-option>
              </el-select>
            </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="reset_handelTransfe('form')">取 消</el-button>
        <el-button type="primary" @click="handelTransfe('form')">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="车辆过户/报废记录" :visible.sync="transferListDialog" class="custom-dialog" width="596px" style="overflow: auto;height: auto">
      <el-table
          :data="transferData"
          stripe
          border
          size="mini"
          :header-cell-style="{background:'#e5e5e5',color:'#333333'}">

        <el-table-column
            label="车牌"
            min-width="30%"
            prop="plate_number"
            :show-overflow-tooltip='true'>
        </el-table-column>

        <el-table-column
            v-if="t_is_del ==3"
            label="过户时间"
            min-width="30%"
            prop="log_time"
            :show-overflow-tooltip='true'>

        </el-table-column>
        <el-table-column
            v-if="t_is_del ==4"
            label="报废时间"
            min-width="30%"
            prop="log_time"
            :show-overflow-tooltip='true'>

        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button  type="success" size="mini"  @click="CancelDispose(transCarId)">取消 过户/报废</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

  import moment from 'moment'     //日期时间转换
  import pagination from "../common/pagination";
  export default {
    name: "carList",
    components: {
      pagination
    },
    props: {},
    data() {
      return {
        activeName: 'first',
        srcList:[],
        // 搜索
        searchForm: {
          username: '',
          keywords: '',
          vin:'',
          is_del:''
        },
        searchRules: {
          name: [
            { required: true, message: "请输入公司名称", trigger: "blur" },
          ],
        },
        // 表头
        tableHeadConfig: [
          {
            label: "ID",
            field: "id"
          },
          {
            label: "产品名称",
            field: "name"
          },
          {
            label: "产品分类",
            columnType: "slot",
            slotName: "categoryName"
          },
          {
            label: "创建时间",
            columnType: "slot",
            slotName: "addTime"
          },
          {
            label: "备注",
            field: "remark"
          },
          {
            label: "操作",
            columnType: "slot",
            slotName: "operation",
            width: 200
          }
        ],
        // 数据
        tableLoadData: [],
        limit: 10,
        pageNum:1,// 当前页码
        total:0,//总条目数
        id: '',
        rules: {
          name: [{ required: true, message: '请输入公司名称', trigger: 'blur' }],
          corporation: [{ required: true, message: '请输入法人', trigger: 'blur' }],
          credit_code: [{ required: true, message: '请输入社会信用代码', trigger: 'blur' }],
        },
        dialogFormVisible: false,
        title: '',
        form: {
          name: '',
          address: '',
          credit_code: '',
          composition: '',
          business_scope: '',
          incorporation_date: '',
          corporation: '',
          registered_capital: '',
          certificate_no: '',
          lifespan: '',
          issue_date: '',
          type: '',
          duty_paragraph: '',
          mobile: '',
          bank: '',
          bank_account: '',
        },
        //车辆档案-查看图片所属信息open
        uploadImg: '',
        uploadDialog: false,
        main_big_book:[],
        hang_big_book:[],
        trading_card:[],
        attachment:[],
        driver_info:[],
        //车辆档案-查看图片所属信息end
        carDisposeDialog:false,
        disposeType:1, //1 过户，2报废
        carId:'',
        transferListDialog:false,
        transCarId:'',
        t_is_del:2,
        transferData:[]
      };
    },
    created() {
      this.DataList()
    },
    mounted() {},
    filters: {
      /**
       * @param {
       *
       * }
       */
      statusFilter(status) {
        if (status == 1) {
          return "启用";
        } else if (status == 2) {
          return "禁用";
        }
      },
      //时间格式化
      dateFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time*1000).format("yyyy-MM-DD HH:mm:ss");
      },

    },
    methods: {
      handleClick(tab, event) {
        //console.log(tab, event);
      },
      bigImg(url) {
        this.srcList = url;
        //console.log('srcList----',this.srcList)
      },
      DataList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          page: this.pageNum,
          pageSize: this.limit,
        }
        if(this.searchForm.keywords){
          param.queryParams=this.searchForm.keywords;
        }
        if(this.searchForm.username){
          param.username=this.searchForm.username;
        }
        if(this.searchForm.vin){
          param.vin=this.searchForm.vin;
        }
        if(this.searchForm.is_del){
          param.is_del=this.searchForm.is_del;
        }
        this.$axios.carFilesList(param).then(res=>{
          if(res.code == 200){
            this.tableLoadData = res.data.data
            this.total = res.data.total
          }else{
            this.$message.error(res.msg);
          }
        }).catch(error=>{
          //console.log(error);
        })
      },


      handleSizeChange(newSize) {
        this.limit = newSize
        this.DataList()
      },
      // 分页跳转

      handleCurrentChange(newPage) {
        this.pageNum = newPage
        this.DataList()
      },

      // 新增
      addData() {
        this.$router.push('carForm')
      },
      handelEdit(row) {
        this.$router.push({
          path:'/carForm',
          query:{
            id:row.id
          }
        })
      },

      reset_dialogForm(formName) {
        this.dialogFormVisible = false
        this.$nextTick(() => {
          this.$refs[formName].resetFields()
        })
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if(!this.id){
              const param = {
                name: this.form.name,
                address: this.form.address,
                credit_code: this.form.credit_code,
                composition: this.form.composition,
                business_scope: this.form.business_scope,
                incorporation_date: this.form.incorporation_date,
                corporation: this.form.corporation,
                registered_capital: this.form.registered_capital,
                certificate_no: this.form.certificate_no,
                lifespan: this.form.lifespan,
                issue_date: this.form.issue_date,
                type: this.form.type,
                duty_paragraph: this.form.duty_paragraph,
                mobile: this.form.mobile,
                bank: this.form.bank,
                bank_account: this.form.bank_account,
                operator_id: sessionStorage.getItem('user_id'),
                company_id:sessionStorage.getItem('company_id'),
                access_token:sessionStorage.getItem('token')
              }
              this.$axios.shopShopSave(param).then(res =>{
                if(res.code == 200){
                  this.DataList()
                  this.$message.success(res.msg)
                  this.dialogFormVisible = false
                }else{
                  this.$message.error(res.msg);
                }
              })
            }else{
              const param = {
                id: this.form.id,
                name: this.form.name,
                address: this.form.address,
                credit_code: this.form.credit_code,
                composition: this.form.composition,
                business_scope: this.form.business_scope,
                incorporation_date: this.form.incorporation_date,
                corporation: this.form.corporation,
                registered_capital: this.form.registered_capital,
                certificate_no: this.form.certificate_no,
                lifespan: this.form.lifespan,
                issue_date: this.form.issue_date,
                type: this.form.type,
                duty_paragraph: this.form.duty_paragraph,
                mobile: this.form.mobile,
                bank: this.form.bank,
                bank_account: this.form.bank_account,
                operator_id: sessionStorage.getItem('user_id'),
                company_id:sessionStorage.getItem('company_id'),
                access_token:sessionStorage.getItem('token')
              }
              this.$axios.shopShopSave(param).then(res =>{
                if(res.code == 200){
                  this.$message.success(res.msg)
                  this.DataList()
                  this.dialogFormVisible = false
                }else{
                  this.$message.error(res.msg);
                }
              })
            }

          }
        })
      },
      searchSubmit() {
        this.DataList();
      },

      handelDel(e) {
        this.$confirm('此操作将删除该车辆？, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const param = {
            company_id:sessionStorage.getItem('company_id'),
            access_token:sessionStorage.getItem('token'),
            id: e.id,
          }
          //console.log(param);
          this.$axios.delCar(param).then(res=>{
            if(res.code == 200){
              this.$message.success(res.msg);
              this.DataList()
            }else{
              this.$message.error(res.msg);
            }
          }).catch(error=>{
            //console.log(error);
          })
        }).catch(() => {
          // 点击取消:不删除了
          this.$message.success('已取消删除');
          this.DataList()
        });
      },
      handDispose(e){
        this.carDisposeDialog = true;
        this.carId = e.id;
      },
      CancelDispose(e){
        console.log('cancel:',e)
        this.$confirm('此操作将还原该车辆？, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const param = {
            company_id:sessionStorage.getItem('company_id'),
            access_token:sessionStorage.getItem('token'),
            id: e
          }
          this.$axios.cancelCar(param).then(res=>{
            if(res.code == 200){
              this.$message.success(res.msg);
              this.reset_CancelDispose();
              this.DataList()
            }else{
              this.$message.error(res.msg);
            }
          })

        }).catch(() => {
          // 点击取消:已取消过户
          this.$message.success('已取消过户');
          this.reset_handelTransfe();
          this.DataList()
        });
      },
      transferList(e,is_del){
        this.transferListDialog = true;
        this.transCarId = e;
        this.t_is_del = is_del;
        this.getTransferData(this.transCarId,this.t_is_del);
      },
      reset_CancelDispose(){
        this.transferListDialog = false;
        this.carId = '';
        this.transCarId = '';
        this.t_is_del = '';
      },
      getTransferData(transCarId,type){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          carId:transCarId,
          type:type
        }
        this.$axios.transCarList(param).then(res=>{
          if(res.code == 200){
            this.transferData = res.data
          }else{
            this.$message.error(res.msg);
          }
        }).catch(error=>{
          //console.log(error);
        })
      },
      reset_handelTransfe(){
        this.carDisposeDialog = false;
        this.carId = '';
      },
      handelTransfe(){
        var transfe = '';
        if(this.disposeType ==1)
          transfe = '过户'
        else
          transfe = '报废'
        this.$confirm('此操作将'+transfe+'该车辆？, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const param = {
            company_id:sessionStorage.getItem('company_id'),
            access_token:sessionStorage.getItem('token'),
            id: this.carId,
            type:this.disposeType
          }
          this.$axios.transferCar(param).then(res=>{
            if(res.code == 200){
              this.$message.success(res.msg);
              this.reset_handelTransfe();
              this.DataList()
            }else{
              this.$message.error(res.msg);
            }
          }).catch(error=>{
            //console.log(error);
          })
        }).catch(() => {
          // 点击取消:已取消过户
          this.$message.success('已取消过户');
          this.reset_handelTransfe();
          this.DataList()
        });
      },
      // 点击弹出当前的图片
      handelDialog(index) {
        //console.log('handelDialog-index-',index);
        this.uploadDialog = true
        this.uploadImg = index
        this.getCarInfo(index.id)
      },
      //获取车辆档案信息
      getCarInfo(car_id){
        let param = {
          id:car_id,
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
        };
        this.$axios.carInfo(param).then(res =>{
          if(res.code == 200){
            this.main_big_book=res.data.main_big_book;
            this.hang_big_book=res.data.hang_big_book;
            this.trading_card=res.data.trading_card;
            this.attachment=res.data.attachment;
            this.driver_info=res.data.driver_info;
          }else{
            this.$message.error(res.msg);
          }
        })
      },
      // getCellStyle({column}){
      //
      // },

    },
  };
</script>
<style>
  .table_name{
    font-weight: bold;
    /* border: 1px solid #f00; */
  }
  .table_name:hover{
    color: #409EFF;
    cursor: pointer;
  }

  .box{}
  .custom-dialog {
    height: auto !important;
  }
  /deep/.el-dialog, /deep/.el-dialog__body{
      height: auto;
  }

</style>



// WEBPACK FOOTER //
// src/view/car/carList.vue